module.exports = __webpack_public_path__ + "static/media/Social_elYoutubecircle_797930.4a2bbb40.png";